// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__EntryEditor__root","controlPane":"cms__EntryEditor__controlPane","previewPane":"cms__EntryEditor__previewPane","blocker":"cms__EntryEditor__blocker","footer":"cms__EntryEditor__footer"};


//////////////////
// WEBPACK FOOTER
// ./components/EntryEditor/EntryEditor.css
// module id = 547
// module chunks = 0